

const isBlank = (value?: string) => {
    return (!value || value.trim().length === 0);
}

const substring = (value?: string, maxLength?: number) => {
    if (StringUtil.isBlank(value)) {
        return undefined;
    }

    const str = value?.trim();
    return maxLength ? str?.substring(0, maxLength) : str;

}

const trim = (value?: string) => {
    return StringUtil.isBlank(value) ? undefined : value?.trim();
}

const replaceNonNumeric = (value?: string) => {
    return value?.replace(/[^0-9]/g, '');
}

const replaceNonAplphanumeric = (value?: string) => {
    return value?.replace(/[^0-9A-Za-z]/g, '');
}

const replaceLineBreak = (str?: string) => {
    return str?.replace(/(\r\n|\n|\r)/gm, '');
}

const replaceCrossSiteScripting = (str?: string) => {
    // <script>&lt; "" alert('XSS')</script>
    return str?.replace(/[<>&"']/gm, '');
}


const StringUtil = {
    isBlank,
    substring,
    trim,
    replaceNonNumeric,
    replaceNonAplphanumeric,
    replaceLineBreak,
    replaceCrossSiteScripting
}

export default StringUtil;